import { render, staticRenderFns } from "./Datamanagement.vue?vue&type=template&id=e5449cac&scoped=true&"
import script from "./Datamanagement.vue?vue&type=script&lang=js&"
export * from "./Datamanagement.vue?vue&type=script&lang=js&"
import style0 from "./Datamanagement.vue?vue&type=style&index=0&id=e5449cac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5449cac",
  null
  
)

export default component.exports